export default "__VITE_ASSET__4zy8vDEQU4KpveeRNJqB5A__"